import React from "react";

import { anim } from "./utils";
import { useAnimationsEnabled } from "../../lib/hooks/useQueryBoard";

const moveUp = (delay: number) => ({
  initial: { y: 150, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.35,
      delay,
      ease: "easeOut",
    },
  },
});

const MoveUp = (props: {
  children: React.ReactElement;
  delay: number;
  disabled?: boolean;
}) => {
  const { children, disabled, delay } = props;

  const animationsEnabled = useAnimationsEnabled();

  if (disabled || !animationsEnabled) {
    return children;
  }

  return React.cloneElement(children, {
    ...anim(moveUp(delay)),
  });
};

export default MoveUp;
